import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, CopyLink, Icon, Link } from 'apps/shared/scripts/components';

import {
  buttonClassName,
  headingClassName,
  iconClassName,
  iconWrapperClassName,
  linkClassName,
  subheadingClassName,
  successActionsClassName,
  successBodyClassName,
  successClassName,
  successHeaderClassName,
} from './styles';

interface Props {
  cardId: string;
  children: ReactNode;
  primaryLabel: string;
  primaryUrl: string;
  secondaryLabel?: string;
  secondaryUrl?: string;
  title?: string;
}

const Success = ({
  cardId,
  children,
  primaryLabel,
  primaryUrl,
  secondaryLabel,
  secondaryUrl,
  title = 'Success!',
}: Props) => {
  const navigate = useNavigate();

  const onDone = useCallback(() => {
    navigate(primaryUrl, { replace: true });
  }, [navigate, primaryUrl]);

  return (
    <div className={successClassName}>
      <div className={successHeaderClassName}>
        <div className={iconWrapperClassName}>
          <Icon className={iconClassName} fa={faCheck} />
        </div>
        <h2 className={headingClassName}>{title}</h2>
        <h4 className={subheadingClassName}>{children}</h4>
      </div>
      <div className={successBodyClassName}>
        <CopyLink url={`${process.env.REACT_APP_URL!}/${cardId}`} />
      </div>
      <div className={successActionsClassName}>
        <Button className={buttonClassName} onClick={onDone} fullWidth>
          {primaryLabel}
        </Button>
        {secondaryLabel && secondaryUrl && (
          <Link className={linkClassName} to={secondaryUrl}>
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

Success.displayName = 'Success';

export default Success;
